import React from 'react';
import {createDrawerNavigator} from '@react-navigation/drawer';
import {useTranslation} from 'react-i18next';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';
import {colors} from '../theme';
import {usePermission} from '../hooks/usePermission';
import CustomDrawerContent from './CustomDrawerContent';
import DashboardScreen from '../screens/dashboard/DashboardScreen';
import OrdersTabNavigator from './OrdersTabNavigator';
import CustomerNavigator from './CustomerNavigator';
import WorkerNavigator from './WorkerNavigator';
import ExpenseNavigator from './ExpenseNavigator';
import InventoryNavigator from './InventoryNavigator';
import StoreNavigator from './StoreNavigator';
import AccountNavigator from './AccountNavigator';
import ReportsScreen from '../screens/reports/ReportsScreen';
import ShareScreen from '../screens/info/ShareScreen';
import ContactUsScreen from '../screens/info/ContactUsScreen';
import FAQScreen from '../screens/info/FAQScreen';
import SettingsNavigator from './SettingsNavigator';


const Drawer = createDrawerNavigator();

const DrawerNavigator = () => {
  const {t} = useTranslation();
  const {hasPermission, isOwner} = usePermission();
  const showWorkers = isOwner || hasPermission('MANAGE_WORKSHOP');
  const showExpenses = isOwner || hasPermission('MANAGE_WORKSHOP');
  const showStores = isOwner || hasPermission('SETTINGS');
  const showReports = isOwner || hasPermission('VIEW_REPORTS');

  return (
    <Drawer.Navigator
      drawerContent={props => <CustomDrawerContent {...props} />}
      screenOptions={{
        headerShown: false,
        drawerActiveTintColor: colors.primary,
        drawerActiveBackgroundColor: colors.primary + '15',
        drawerInactiveTintColor: colors.text,
        drawerLabelStyle: {marginLeft: -8, fontSize: 16},
      }}>
      <Drawer.Screen
        name="Dashboard"
        component={DashboardScreen}
        options={{
          drawerLabel: t('nav.dashboard'),
          drawerIcon: ({color, size}) => (
            <MaterialCommunityIcons name="view-dashboard" color={color} size={size} />
          ),
        }}
      />
      {showStores && (
        <Drawer.Screen
          name="Stores"
          component={StoreNavigator}
          options={{
            drawerLabel: t('nav.stores'),
            drawerIcon: ({color, size}) => (
              <MaterialCommunityIcons name="store" color={color} size={size} />
            ),
          }}
        />
      )}
      <Drawer.Screen
        name="Orders"
        component={OrdersTabNavigator}
        options={{
          drawerLabel: t('nav.orders'),
          drawerIcon: ({color, size}) => (
            <MaterialCommunityIcons name="clipboard-list" color={color} size={size} />
          ),
        }}
      />
      <Drawer.Screen
        name="Customers"
        component={CustomerNavigator}
        options={{
          drawerLabel: t('nav.customers'),
          drawerIcon: ({color, size}) => (
            <MaterialCommunityIcons name="account-group" color={color} size={size} />
          ),
        }}
      />
      {showWorkers && (
        <Drawer.Screen
          name="Workers"
          component={WorkerNavigator}
          options={{
            drawerLabel: t('nav.workers'),
            drawerIcon: ({color, size}) => (
              <MaterialCommunityIcons name="account-hard-hat" color={color} size={size} />
            ),
          }}
        />
      )}
      {showExpenses && (
        <Drawer.Screen
          name="Expenses"
          component={ExpenseNavigator}
          options={{
            drawerLabel: t('nav.expenses'),
            drawerIcon: ({color, size}) => (
              <MaterialCommunityIcons name="cash-minus" color={color} size={size} />
            ),
          }}
        />
      )}
      {showExpenses && (
        <Drawer.Screen
          name="Inventory"
          component={InventoryNavigator}
          options={{
            drawerLabel: t('nav.inventory'),
            drawerIcon: ({color, size}) => (
              <MaterialCommunityIcons name="package-variant-closed" color={color} size={size} />
            ),
          }}
        />
      )}
      {showReports && (
        <Drawer.Screen
          name="Reports"
          component={ReportsScreen}
          options={{
            drawerLabel: t('nav.reports'),
            drawerIcon: ({color, size}) => (
              <MaterialCommunityIcons name="chart-bar" color={color} size={size} />
            ),
          }}
        />
      )}
      <Drawer.Screen
        name="Settings"
        component={SettingsNavigator}
        options={{
          drawerLabel: t('nav.settings'),
          drawerIcon: ({color, size}) => (
            <MaterialCommunityIcons name="cog" color={color} size={size} />
          ),
        }}
      />
      <Drawer.Screen
        name="MyAccount"
        component={AccountNavigator}
        options={{
          drawerLabel: t('nav.myAccount'),
          drawerIcon: ({color, size}) => (
            <MaterialCommunityIcons name="account-circle" color={color} size={size} />
          ),
        }}
      />
      <Drawer.Screen
        name="Share"
        component={ShareScreen}
        options={{
          drawerLabel: t('nav.share'),
          drawerIcon: ({color, size}) => (
            <MaterialCommunityIcons name="share-variant" color={color} size={size} />
          ),
        }}
      />
      <Drawer.Screen
        name="ContactUs"
        component={ContactUsScreen}
        options={{
          drawerLabel: t('nav.contactUs'),
          drawerIcon: ({color, size}) => (
            <MaterialCommunityIcons name="phone-message" color={color} size={size} />
          ),
        }}
      />
      <Drawer.Screen
        name="FAQ"
        component={FAQScreen}
        options={{
          drawerLabel: t('nav.faq'),
          drawerIcon: ({color, size}) => (
            <MaterialCommunityIcons name="frequently-asked-questions" color={color} size={size} />
          ),
        }}
      />
    </Drawer.Navigator>
  );
};

export default DrawerNavigator;
